import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4b0fb48f"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b0fb48f')) {
      api.createRecord('4b0fb48f', component.options)
    } else {
      api.reload('4b0fb48f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4b0fb48f", function () {
      api.rerender('4b0fb48f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/Plants/Plant/Stock/index.vue"
export default component.exports